import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=0164a29c&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=js&"
export * from "./TabView.vue?vue&type=script&lang=js&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=0164a29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164a29c",
  null
  
)

export default component.exports